var map = {
	"./avatars/avatar": 34,
	"./avatars/avatar-3": 35,
	"./avatars/avatar-3.png": 35,
	"./avatars/avatar.jpg": 34,
	"./errors-images/404-error": 36,
	"./errors-images/404-error.png": 36,
	"./errors-images/505-error": 37,
	"./errors-images/505-error.png": 37,
	"./lexiqamus-logo": 38,
	"./lexiqamus-logo.png": 38,
	"./lexiqamus-sidebar-logo": 39,
	"./lexiqamus-sidebar-logo.png": 39,
	"./lexiqamus/ekual-announcement-megaphone": 17,
	"./lexiqamus/ekual-announcement-megaphone.svg": 17,
	"./lexiqamus/innovation_announcements/hareket1": 18,
	"./lexiqamus/innovation_announcements/hareket1.jpg": 18,
	"./lexiqamus/innovation_announcements/hareket2": 19,
	"./lexiqamus/innovation_announcements/hareket2.jpg": 19,
	"./lexiqamus/innovation_announcements/hareket3": 20,
	"./lexiqamus/innovation_announcements/hareket3.jpg": 20,
	"./lexiqamus/innovation_announcements/hareket4": 21,
	"./lexiqamus/innovation_announcements/hareket4.jpg": 21,
	"./lexiqamus/innovation_announcements/original-document": 22,
	"./lexiqamus/innovation_announcements/original-document.png": 22,
	"./lexiqamus/innovation_announcements/smart-results": 23,
	"./lexiqamus/innovation_announcements/smart-results.png": 23,
	"./logo-icon": 40,
	"./logo-icon.png": 40,
	"./lq-logo": 41,
	"./lq-logo.png": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;